<div class="background-container container">
  <div class="outer-container">
    <ng-container *ngIf="site">
      <div class="site-detail-heading-container">
        <div class="site-info-container">
          <div class="site-name-row">
            <span>{{ site.name }}</span>
          </div>
          <div class="status-and-action">
            <div class="site-status">
              Status:
              <span>{{ site.status }}</span>
            </div>
            <ng-container *ngIf="showReportDisturbanceButton">
              <button (click)="reportDisturbance()" color="primary" mat-raised-button>Report On Disturbance</button>
            </ng-container>
            <ng-container *ngIf="showReportPeriodicButton">
              <button (click)="reportPeriodic()" color="primary" data-cy="button-complete-report" mat-raised-button>
                Complete Report
              </button>
            </ng-container>
            <button
              (click)="doOpenSite()"
              class="button-margin-right"
              id="view-map-link"
              color="primary"
              mat-stroked-button>
              View Map
            </button>
          </div>
        </div>
        <mat-divider></mat-divider>
      </div>

      <div class="buyer-header-bar">
        <ng-container *ngIf="site && site.cohort.buyer">
          <img
            [alt]="site.cohort.buyer.name"
            [ngClass]="site.cohort.buyer.shortName"
            [src]="getOpenAssetURL(site.cohort.buyer.shortName, 'logo.svg')" />
        </ng-container>
        <div class="total-annual-value-container">
          Estimated Annual Revenue:
          <div class="valuation">
            {{ valuePerYear }}
            <fa-icon
              #tooltip="matTooltip"
              (click)="tooltip.toggle()"
              [icon]="['far', 'circle-info']"
              class="blue size-18"
              matTooltip="Estimated annual revenue is the base payout for the next year of payments. This value can change based on your responses to periodic reporting or on market performance."
              matTooltipClass="fc-tooltip"
              matTooltipPosition="right"></fa-icon>
          </div>
        </div>
      </div>

      <div class="accordion-container">
        <mat-accordion [togglePosition]="'before'" multi>
          <fc-site-detail-information [isAdmin]="false"></fc-site-detail-information>

          <fc-site-detail-payments></fc-site-detail-payments>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title data-cy="documents-header">Upload and View Documents</mat-panel-title>
            </mat-expansion-panel-header>
            <mat-divider></mat-divider>
            <fc-site-doc-list [activeSite]="site"></fc-site-doc-list>
          </mat-expansion-panel>

          <fc-site-detail-reports [isAdmin]="false" [site]="site"></fc-site-detail-reports>
        </mat-accordion>
      </div>
    </ng-container>
  </div>
</div>
